var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep501(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9,
    r: 48.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.4 74.9c-2.9 0-5.7-0.5-8.5-1.6s-4.9-2.4-6.4-3.9l5.5-8.5c0.9 1.1 2.1 2 3.8 2.7 1.6 0.7 3.2 1.1 4.8 1.1 1.1 0 2.2-0.2 3.2-0.7s1.8-1.2 2.4-2.2 0.9-2.2 0.9-3.6c0-1.6-0.3-2.9-0.9-4.1s-1.5-2.1-2.7-2.8-2.5-1-4.1-1c-1.5 0-3 0.2-4.3 0.6-1.4 0.4-3 1.1-4.9 2.1h-0.1v-27.5h24.4v10.3h-15.2v7.9l-1.3-2.3c0.7-0.1 1.4-0.2 2-0.2s1.3-0.1 1.9-0.1c3.4 0 6.3 0.8 8.7 2.3s4.2 3.5 5.5 6 1.9 5.2 1.9 8.2c0 3.2-0.7 6.2-2.2 8.8s-3.5 4.7-6 6.2-5.3 2.3-8.4 2.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep501);
export default __webpack_public_path__ + "static/media/step5-01.796739a3508e36bed8c0f818d876b669.svg";
export { ForwardRef as ReactComponent };